module.exports = __webpack_public_path__ + "media/images/case-manager-d7387a48.png";